export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "workerName.c9877cb25fef273d.js");
}
